import {
  Container,
  Icon,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { Context, useContext } from "../Context";
import Loading from "../components/Loading";
import GreyButton from "../components/GreyButton";
import { ReactComponent as SwyftxLogo } from "../assets/6385b3d7140115fbf69f92db_SwyftX Logo.svg";
import { ReactComponent as CommbankLogo } from "../assets/commonwealth-bank-2-logo-svg-vector.svg";
import { ReactComponent as SelfWealthLogo } from "../assets/Selfwealth New 2022.svg";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate } from "react-router-dom";
import EditCommbankLink from "../components/EditLinks/EditCommbankLink";
import EditSelfWealthLink from "../components/EditLinks/EditSelfWealthLink";
import EditSwyftxLink from "../components/EditLinks/EditSwyftxLink";
import MessageModal from "../components/MessageModal";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { URL, origin } from "../config";
import { Helmet } from "react-helmet-async";

export default function ManagePlatforms() {
  // const theme = createTheme({
  //     secondary: "#EEEEEE"
  // })

  const navigate = useNavigate();
  const { userName } = useContext(Context);
  const [userInfo, setUserInfo] = React.useState({});
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [openEditCommbank, setOpenEditCommbank] = React.useState(false);
  const [openEditSelfwealth, setOpenEditSelfwealth] = React.useState(false);
  const [openEditSwyftx, setOpenEditSwyftx] = React.useState(false);

  React.useEffect(() => {
    fetch(`${URL}/user?` + new URLSearchParams({ username: userName }), {
      method: "GET",
      mode: "cors",
      credentials: "include",
      headers: {
        "content-type": "application/json",
        Origin: `${origin}`,
      },
    })
      .then(async (response) => {
        return {
          data: await response.json(),
          code: response.status,
        };
      })
      .then((data) => {
        if (data.code !== 200) {
          navigate(`/${data.code}`);
          setError(data.data.message);
          throw new Error(data.data.message);
        } else {
          setUserInfo(data.data);
        }
        setLoading(false);
      });
  }, []);

  const closeAlert = () => {
    setError("");
  };

  const handleLinkCommbank = () => {
    navigate("/link/commbank");
  };
  const handleEditCommbank = () => {
    setOpenEditCommbank(true);
  };

  const handleEditSelfwealth = () => {
    setOpenEditSelfwealth(true);
  };

  const handleEditSelfwealthClose = () => {
    setOpenEditSelfwealth(false);
  };

  const handleEditSwyftx = () => {
    setOpenEditSwyftx(true);
  };

  const handleEditSwyftxClose = () => {
    setOpenEditSwyftx(false);
  };

  const handleLinkSwyftx = () => {
    navigate("/link/swyftx");
  };
  const handleLinkSelfWealth = () => {
    navigate("/link/selfwealth");
  };

  const handleEditCommbankClose = () => {
    setOpenEditCommbank(false);
  };

  return (
    <>
      <Helmet>
        <title>WealthWatch | manage services</title>
      </Helmet>
      {loading ? (
        <Loading />
      ) : (
        <Container
          sx={{
            backgroundColor: "primary.main",
            my: 4,
            py: 3,
            borderRadius: 2,
            boxShadow: 24,
            color: "primary.contrastText",
            "@media (max-width: 75em)": {
              width: "90%",
            },
          }}
          maxWidth="md"
        >
          <Typography variant="h6">Manage your linked accounts</Typography>
          <List sx={{ width: "100%", my: 2 }}>
            <ListItem disablePadding divider sx={{ my: 1, py: 1 }}>
              <ListItemText
                primary={
                  <SwyftxLogo
                    style={{
                      height: "20px",
                      marginLeft: -5,
                      width: "75px",
                      marginRight: "5px",
                    }}
                  />
                }
              />
              {userInfo.services.swyftx.isLinked ? (
                <Typography sx={{ color: "green" }}>ACTIVE</Typography>
              ) : (
                <Typography sx={{ color: "red" }}>INACTIVE</Typography>
              )}
              <Icon sx={{ px: 1 }}>
                {userInfo.services.swyftx.isLinked ? (
                  <CheckCircleOutlineIcon color="success" />
                ) : (
                  <CancelIcon color="error" />
                )}
              </Icon>
              {userInfo.services.swyftx.isLinked ? (
                <GreyButton onClick={handleEditSwyftx}>edit</GreyButton>
              ) : (
                <GreyButton onClick={handleLinkSwyftx}>link</GreyButton>
              )}
            </ListItem>
            <ListItem disablePadding divider sx={{ my: 1 }}>
              <ListItemText
                primary={
                  <CommbankLogo
                    style={{ height: "40px", width: "120px", marginLeft: -5 }}
                  />
                }
              />
              {userInfo.services.commbank.isLinked ? (
                <Typography sx={{ color: "green" }}>ACTIVE</Typography>
              ) : (
                <Typography sx={{ color: "red" }}>INACTIVE</Typography>
              )}
              <Icon sx={{ px: 1 }}>
                {userInfo.services.commbank.isLinked ? (
                  <CheckCircleOutlineIcon color="success" />
                ) : (
                  <CancelIcon color="error" />
                )}
              </Icon>
              {userInfo.services.commbank.isLinked ? (
                <GreyButton onClick={handleEditCommbank}>edit</GreyButton>
              ) : (
                <GreyButton onClick={handleLinkCommbank}>link</GreyButton>
              )}
            </ListItem>
            <ListItem disablePadding divider sx={{ my: 1 }}>
              <ListItemText
                primary={
                  <SelfWealthLogo style={{ height: "50px", marginLeft: -5 }} />
                }
              />
              {userInfo.services.selfwealth.isLinked ? (
                <Typography sx={{ color: "green" }}>ACTIVE</Typography>
              ) : (
                <Typography sx={{ color: "red" }}>INACTIVE</Typography>
              )}
              <Icon sx={{ px: 1 }}>
                {userInfo.services.selfwealth.isLinked ? (
                  <CheckCircleOutlineIcon color="success" />
                ) : (
                  <CancelIcon color="error" />
                )}
              </Icon>
              {userInfo.services.selfwealth.isLinked ? (
                <GreyButton onClick={handleEditSelfwealth}>edit</GreyButton>
              ) : (
                <GreyButton onClick={handleLinkSelfWealth}>link</GreyButton>
              )}
            </ListItem>
          </List>
        </Container>
      )}
      <EditCommbankLink
        open={openEditCommbank}
        close={handleEditCommbankClose}
      ></EditCommbankLink>
      <EditSelfWealthLink
        open={openEditSelfwealth}
        close={handleEditSelfwealthClose}
      ></EditSelfWealthLink>
      <EditSwyftxLink
        open={openEditSwyftx}
        close={handleEditSwyftxClose}
      ></EditSwyftxLink>
      <MessageModal
        severity="error"
        title="error"
        open={error ? true : false}
        onClose={closeAlert}
      >
        {error}
      </MessageModal>
    </>
  );
}
